import { authorClient } from "@/api/authorClient";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData } from "@/utils";
import {
  DeletePermReq,
  UpdatePermReq,
  CreatePermReq,
  GetResourceByPermReq,
  AssignResourceToPermReq,
  DeleteResourceFromPermReq,
  UpdateResourcePermBindingReq
} from "@/pbjs/external/auth/auth_pb";
// lee 绩效接口参数
interface Options {
  permid?: string | number; // 待删除的权限ID
  parentPermId?: string; // 修改（新的父级别ID，如果没有修改层级，传-1）、新增（父亲权限的ID，如果新建最高级传0）
  name?: string; // 新名字，没更改就传空
  Annotation?: string; // 新注释，没更改就传空
  resourceId?:any; // 路由id
  resourceIds?:any; //分配的资源列表，如果只有一个，传一个元素的列表
  type?: string | number; // 菜单 1; 按钮 2;
  specifiedMenuId?: number; // 页面id;
  bindingid?: string;
}
// 获取菜单树
export function getPageTree(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
        let request: any = setCommon();
      // setRank
      let _res = await authorClient.getMenuTree(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
  .then((response: any) => {
    response.loading = false;
    handleResponse(response, null);
    return response;
  })
  .catch((err: any) => {
    errorMsg(err);
  });
}
// 删除页面、按钮
export function deletePage(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new DeletePermReq();
      request.setCommonin(setCommon());
      request.setPermid(arg.permid);
      // setRank
      let _res = await authorClient.deletePerm(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
  .then((response: any) => {
    response.loading = false;
    handleResponse(response, null);
    return response;
  })
  .catch((err: any) => {
    errorMsg(err);
  });
}
// 更新页面、按钮
export function updatePage(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new UpdatePermReq();
      request.setCommonin(setCommon());
      request.setPermid(arg.permid);
      request.setParentpermid(arg.parentPermId);
      request.setName(arg.name);
      // setRank
      let _res = await authorClient.updatePerm(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
  .then((response: any) => {
    response.loading = false;
    handleResponse(response, null);
    return response;
  })
  .catch((err: any) => {
    errorMsg(err);
  });
}
// 新增页面、按钮
export function createPage(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new CreatePermReq();
      request.setCommonin(setCommon());
      request.setParentpremid(arg.parentPermId);
      request.setName(arg.name);
      if(arg.type){
        request.setType(arg.type);
      }
      request.setSpecifiedmenuid(arg.specifiedMenuId);
      // setRank
      let _res = await authorClient.createPerm(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
  .then((response: any) => {
    response.loading = false;
    handleResponse(response, null);
    return response;
  })
  .catch((err: any) => {
    errorMsg(err);
  });
}
//  根据权限获取下属的资源接口
export function getPerm(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetResourceByPermReq();
      request.setCommonin(setCommon());
      request.setPermid(arg.permid);
      // setRank
      let _res = await authorClient.getResourceByPerm(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
  .then((response: any) => {
    response.loading = false;
    handleResponse(response, null);
    return response;
  })
  .catch((err: any) => {
    errorMsg(err);
  });
}
// 删除权限
export function deletePerm(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new DeleteResourceFromPermReq();
      request.setCommonin(setCommon());
      request.setPermid(arg.permid);
      request.setResourceid(arg.resourceId);
      // setRank
      let _res = await authorClient.deleteResourceFromPerm(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
  .then((response: any) => {
    response.loading = false;
    handleResponse(response, null);
    return response;
  })
  .catch((err: any) => {
    errorMsg(err);
  });
}
// 新增权限
export function createPerm(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new AssignResourceToPermReq();
      request.setCommonin(setCommon());
      request.setPermid(arg.permid);
      request.setResourceidsList(arg.resourceIds);
      // setRank
      let _res = await authorClient.assignResourceToPerm(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
  .then((response: any) => {
    response.loading = false;
    handleResponse(response, null);
    return response;
  })
  .catch((err: any) => {
    errorMsg(err);
  });
}
// 更新权限
export function updatePerm(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new UpdateResourcePermBindingReq();
      request.setCommonin(setCommon());
      request.setBindingid(arg.bindingid);
      request.setPermid(arg.permid);
      request.setResourceid(arg.resourceId);
      // setRank
      let _res = await authorClient.updateResourcePermBinding(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
  .then((response: any) => {
    response.loading = false;
    handleResponse(response, null);
    return response;
  })
  .catch((err: any) => {
    errorMsg(err);
  });
}
